import React from 'react';
import { motion } from 'framer-motion';
export function AnnouncementBar() {
  return <div className="bg-primary text-white py-2 px-4 text-center text-sm font-medium z-50 relative" data-id="element-16">
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="flex items-center justify-center gap-2 flex-wrap" data-id="element-17">
        <span data-id="element-18">🎉 LIMITED TIME OFFER</span>
        <span className="hidden sm:inline" data-id="element-19">—</span>
        <span className="font-bold bg-white/20 px-2 py-0.5 rounded-full animate-pulse-slow" data-id="element-20">
          50% OFF
        </span>
        <span className="hidden sm:inline" data-id="element-21">—</span>
        <span data-id="element-22">
          <span className="line-through opacity-75 mr-1" data-id="element-23">Was $24.90</span>
          <span className="font-bold" data-id="element-24">Now $14.90</span>
        </span>
      </motion.div>
    </div>;
}